import type { TriggerProps } from "./types-trigger";
import { useTableActionsMenuTrigger } from "./use-trigger";
import { TableActionsMenuTriggerView } from "./view-trigger";

export function TableActionsMenuTrigger(props: TriggerProps) {
  const viewModel = useTableActionsMenuTrigger(props);

  return <TableActionsMenuTriggerView {...viewModel} />;
}
TableActionsMenuTrigger.displayName = "TableActionsMenu.Trigger";
TableActionsMenuTrigger.isTrigger = true;
